import React from "react";

import DynamicTable from "../../../components/DynamicTable";
import { date } from "../formatters";

function AuditTable({ data }) {
  return (
    <>
      <DynamicTable
        showAction={false}
        rowKey="id"
        dataSource={data.audit}
        columns={[
          {
            title: "Administrator",
            dataIndex: "admin_id",
          },
          {
            title: "Action",
            dataIndex: "action",
          },
          {
            title: "Reason",
            dataIndex: "reason",
          },
          {
            title: "Date",
            dataIndex: "createdAt",
            render: date,
          },
        ]}
        expandable={{
          expandedRowRender: (row) => (
            <pre
              style={{
                whiteSpace: "pre-wrap",
              }}
            >
              {JSON.stringify(row.detail, null, 2)}
            </pre>
          ),
        }}
      />
    </>
  );
}
export default AuditTable;
